function triggerAnalyticsEvent(area, action, details = undefined) {
    const eventName = `${area}${action}`;
    try {
        window.$('body').trigger('onAnalyticsTagEvent',
        {
            EventType: 'custom link',
            EventName: eventName,
            CustomEventData: {
                PageSection: window.utag_data.PageSection,
                PageInteractionArea: area,
                PageInteractionTool: '',
                PageInteractionAction: action,
                PageInteractionDetails: details
            }
        });
    } catch (ex) {
        try {
            const vp = window.vp;

            if (vp && vp.instrumentation && vp.instrumentation.logException) {
                vp.instrumentation.logException(ex);
            }
        } catch (ex2) {

        }
    }
}

export function fireBriefPageHit() {
    triggerAnalyticsEvent('BriefPage', 'Hit');
}

export function fireReadOnlyBriefPageHit() {
    triggerAnalyticsEvent('ReadOnlyBriefPage', 'Hit');
}

export function fireSchedulePageHit() {
    triggerAnalyticsEvent('SchedulePage', 'Hit');
}

export function firePickYourTimeCTAClicked() {
    triggerAnalyticsEvent('PickYourTimeCTA', 'Clicked');
}

export function fireStandardDifySaveCTAClicked() {
    triggerAnalyticsEvent('StandardDifySaveCTA', 'Clicked');
}

export function fireStandardDifyCheckoutCTAClicked() {
    triggerAnalyticsEvent('StandardDifyCheckoutCTA', 'Clicked');
}

export function fireCoDesignCheckoutCTAClicked(calendarId) {
    triggerAnalyticsEvent('CoDesignCheckoutCTA', 'Clicked', calendarId);
}

export function firePreviousDesignerCount(count) {
    triggerAnalyticsEvent('CoDesignPreviousDesigners', 'Count', count);
}

export function fireSchedulePageStandardDifyCheckoutCTAClicked() {
    triggerAnalyticsEvent('SchedulePageStandardDifyCheckoutCTA', 'Clicked');
}

export function fireYesCoDesignRadioClicked() {
    triggerAnalyticsEvent('YesCoDesignRadio', 'Clicked')
}

export function fireNoCoDesignRadioClicked() {
    triggerAnalyticsEvent('NoCoDesignRadio', 'Clicked');
}

export function fireProductDropdownSelectedInitialProduct(pfid) {
    triggerAnalyticsEvent('ProductDropdown', 'SelectedInitialProduct', pfid);
}

export function fireProductDropdownChangedProduct(pfid) {
    triggerAnalyticsEvent('ProductDropdown', 'ChangedProduct', pfid);
}

export function fireProductDropdownUnSelectedProduct() {
    triggerAnalyticsEvent('ProductDropdown', 'UnSelectedProduct');
}

export function fireUploadCTAAddedUpload() {
    triggerAnalyticsEvent('UploadCTA', 'AddedUpload');
}

export function fireUploadCTARemovedUpload() {
    triggerAnalyticsEvent('UploadCTA', 'RemovedUpload')
}

export function fireUploadCTAClicked() {
    triggerAnalyticsEvent('UploadCTA', 'Clicked')
}

export function fireTimePickerChangedTime(timeOfDay) {
    const acceptableTimesOfDay = ['morning', 'afternoon', 'evening'];

    if (!acceptableTimesOfDay.includes(timeOfDay)) {
        throw new Error(`Expected timeOfDay to be one of ${acceptableTimesOfDay}. Got ${timeOfDay}`);
    }

    triggerAnalyticsEvent('TimePicker', 'ChangedTime', timeOfDay);
}

export function fireDatePickerChangedDate(dayOfTheweek) {
    const acceptableDaysOfTheWeek = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

    if (!acceptableDaysOfTheWeek.includes(dayOfTheweek)) {
        throw new Error(`Expected dayOfTheWeek to be one of ${acceptableDaysOfTheWeek}. Got ${dayOfTheweek}`);
    }

    triggerAnalyticsEvent('DatePicker', 'ChangedDate', dayOfTheweek);
}

export function fireTimezonePickerChangedTimezone(timezone) {
    triggerAnalyticsEvent('TimezonePicker', 'ChangedTimezone', timezone);
}

export function fireProductConfigurationListShown() {
    triggerAnalyticsEvent('ProductConfigurationList', 'Shown');
}

export function fireProductConfigurationListRemovedProductConfiguration() {
    triggerAnalyticsEvent('ProductConfigurationList', 'RemovedProductConfiguration');
}

export function fireROBriefBackButtonClicked() {
    triggerAnalyticsEvent('ROBriefBackButton', 'Clicked');
}

export function fireBriefCustomerTooltipExpanded() {
    triggerAnalyticsEvent('BriefCustomerTooltipExpander', 'Clicked');
}



// WEBPACK FOOTER //
// ./src/utils/Tracking.js